(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairImportScheduleUrlModalController', VirtualFairImportScheduleUrlModalController)

    VirtualFairImportScheduleUrlModalController.$inject = ['API_BASE', '$uibModalInstance', 'virtualFair', '$scope', 'FileUploader', 'toastr'];

    function VirtualFairImportScheduleUrlModalController(API_BASE, $uibModalInstance, virtualFair, $scope, FileUploader, toastr) {
        var vm = this;

        vm.virtualFair = virtualFair

        vm.ok     = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
            $scope.uploader = new FileUploader({
                url: API_BASE + '/virtualfairs/import-schedule-url',
                withCredentials: false,
                method: 'POST',
                formData: [
                    {
                        'virtual_fair_id': vm.virtualFair.id
                    }
                ],
                headers: {
                    'Authorization': 'Bearer ' +  localStorage.getItem('id_token')
                },
                removeAfterUpload: false,
                onCompleteItem: function(fileItem, response, status, headers) {
                    if (response.success)
                        toastr.success(response.message);
                    else if (response.message)
                        toastr.error(response.message);
                }
            });
        }


        function ok() {
            $uibModalInstance.close();
        }


        function cancel() {
            $uibModalInstance.close();
        }
    }

})();
